var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-end h-100 w-100"},[_vm._t("iFrameContent",function(){return [_vm._v("empty")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }